/* istanbul ignore file */
import React from 'react';
import { InputList, InputListProps } from 'framework/form';

const RequiredResourcesListInput = ({ inputTemplate, ...props }: InputListProps) => {
  return <InputList inputTemplate={inputTemplate} {...props} defaultValue={{}} />;
};

export default RequiredResourcesListInput;
